import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { menuInstituicao, menuPatient, menuPractitioner, menuSecretary } from 'app/core/data/menu.json';
import { CurrentUser } from 'app/core/interfaces/currentUser';
import { Login, Menu } from 'app/core/interfaces/menu';
import { AuthService } from 'app/core/http/services/auth.service';

@Component({
  selector: 'page-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
})
export class SidebarMenuComponent implements OnInit, AfterViewInit {
  public menus: Menu[] = [];
  public user: CurrentUser = <CurrentUser>{};
  public showTooltip = false;

  public get userTypeText(): string {
    if (this.user && this.user.user && this.user.type) {
      switch (this.user.type) {
        case 'organization':
          return 'Instituição';
        case 'practitioner':
          return 'Especialista';
        case 'secretary':
          return 'Secretária';
        default:
          return 'Paciente';
      }
    }
    return '';
  }

  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.user = this.auth.currentUserValue;
    this.menus = this.getMenu();
  }

  ngAfterViewInit() {
    const menuSize = document.querySelector('mat-list')?.clientWidth || 0;
    document.querySelectorAll('mat-list-item button').forEach((item) => {
      const itemSize = item.scrollWidth;
      if (itemSize > menuSize) {
        this.showTooltip = true;
        this.changeDetector.detectChanges();
      }
    });
  }

  public getMenu() {
    if (this.user && this.user.user && this.user.type) {
      switch (this.user.type) {
        case 'organization':
          return menuInstituicao;
        case 'practitioner':
          return menuPractitioner;
        case 'secretary':
          return menuSecretary;
        default:
          return menuPatient;
      }
    }
    return menuPractitioner;
  }

  public gotToPage(page: string) {
    this.router.navigate([page]);
  }
}
